<template>
  <section class="ProductMenu" :class="{'notAvailable': !productShippingInfo.available}">
    <!-- RESUME -->
    <div class="ProductMenu-resume">
      <div class="container">
        <div class="ProductMenu-left">
          <div class="ProductMenu-thumbnail">
            <img :data-src="productThumbnail" class="ProductMenu-thumbnailImage lazyload" />
          </div>
          <div class="ProductMenu-presentation">
            <ProductPresentation :sticky="true"></ProductPresentation>
            <StarRating
              :rating="Number(productReviewsAverage.rate)"
              v-bind:increment="0.1"
              v-bind:read-only="true"
              v-bind:max-rating="5"
              v-bind:star-size="24"
            ></StarRating>
          </div>
        </div>
        <div class="ProductMenu-right">
          <ProductPriceCart
            v-if="productCurrentTva"
            :displayPromo="false"
            :displayTooltip="false"
            :originalPrice="productBillInfo.originalPrice[productCurrentTva]"
            :specialPrice="productBillInfo.specialPrice[productCurrentTva] + additionalInfo"
          ></ProductPriceCart>
          <ButtonProduct></ButtonProduct>
        </div>
      </div>
    </div>
    <!-- LINKS -->
    <div class="ProductMenu-links" v-if="menuProduct.length > 0">
      <div class="container">
        <ul class="ProductMenu-list" :class="{ fill: currentScrolledElement.length > 0 }">
          <li v-for="(item, index) in menuProduct" class="ProductMenu-listItem" :key="index">
            <a
              class="ProductMenu-listLink"
              @click.prevent="scrollToElementId"
              :data-target="item.link"
              :data-adjustmentscroll="item.adjustmentscroll"
              >{{ item.name }}</a
            >
            <ProgressNavItem
              v-if="currentScrolledElement.includes(item.link)"
              :itemId="item.link"
            ></ProgressNavItem>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import ProductPresentation from "@/components/Product/ProductPresentation/ProductPresentation.vue";
import ProductPriceCart from "@/includes/Product/ProductPrice/ProductPriceCart.vue";
import ProgressNavItem from "@/components/ProgressNavItem/ProgressNavItem.vue";
import ButtonProduct from "@/components/ButtonProduct/ButtonProduct.vue";
import StarRating from "vue-star-rating";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import "@/components/Product/ProductMenu/ProductMenu.scss";

export default {
  name: "ProductMenu",

  components: {
    ProductPresentation,
    ProductPriceCart,
    ProgressNavItem,
    StarRating,
    ButtonProduct,
  },

  data () {
    return {
      currentScrolledElement: [],
      adjustmentScroll: 120,
    };
  },

  props: {
    menuProduct: {
      type: Array,
      required: true,
    },
  },

  methods: {
    handleScrollForLink () {
      this.menuProduct.forEach(el => {
        var key = el.link;
        const link = document.getElementById(key);
        const navItem = document.querySelector("[data-target=" + key + "]");

        let adjustmentScrollCustom = 0;
        if(navItem.getAttribute("data-adjustmentscroll") != '') {
          adjustmentScrollCustom = navItem.getAttribute("data-adjustmentscroll");
        }

        if (link) {
          this.addBoldToMenuItem(navItem, link, adjustmentScrollCustom);
          this.addProgressNavBar(key, link, adjustmentScrollCustom);
        }
      });
    },

    addBoldToMenuItem (navItem, link, adjustmentScrollCustom) {
      const appOffsetTop = document.getElementById("app").offsetTop;

      adjustmentScrollCustom = -400;

      if (link && window.scrollY - this.adjustmentScroll - adjustmentScrollCustom - appOffsetTop >= link.offsetTop) {
        navItem.classList.add("bold");
      } else {
        navItem.classList.remove("bold");
      }
    },
    addProgressNavBar (key, link, adjustmentScrollCustom) {
      const appOffsetTop = document.getElementById("app").offsetTop;

      adjustmentScrollCustom = -400;

      if (window.scrollY - this.adjustmentScroll - adjustmentScrollCustom - appOffsetTop >= link.offsetTop) {
        if (!this.currentScrolledElement.includes(key)) {
          this.currentScrolledElement.push(key);
        }
      } else {
        const index = this.currentScrolledElement.indexOf(key);
        if (index > -1) {
          this.currentScrolledElement.splice(index, 1);
        }
      }
    },

    scrollToElementId (event) {
      let target = document.getElementById(event.target.getAttribute("data-target"));
      let adjustmentScrollCustom = 0;
      if(event.target.getAttribute("data-adjustmentscroll") != '') {
        adjustmentScrollCustom = event.target.getAttribute("data-adjustmentscroll");
      }

      const appOffsetTop = document.getElementById("app").offsetTop;

      window.scrollTo(0, target.offsetTop + this.adjustmentScroll + appOffsetTop - adjustmentScrollCustom);
    },
  },

  created () {
    this.handleDebouncedScrollForLink = debounce(this.handleScrollForLink, 1);
    window.addEventListener("scroll", this.handleDebouncedScrollForLink);
  },

  computed: {
    ...mapGetters({
      productThumbnail: "getProductThumbnail",
      productNotice: "getProductNotice",
      productBillInfo: "getProductBillInfo",
      productCurrentTva: "getProductTVAForCurrentDelivery",
      productReviewsAverage: "getProductReviewsAverage",
      additionalInfo: "getPreprendCartAdditionalInfo",
      productShippingInfo: "getProductShippingInfo"
    }),
  },
};
</script>
